module.exports = __webpack_public_path__ + "img/icon-notif-new.ac67b90f.svg";